// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__101CQ","title":"InfoRow_title__jnSCn"};